export default "__VITE_ASSET__BqXLNR4N__"